import { element } from './util.ts';

export const isEmojiPickerContainer = (target: EventTarget | null): boolean => {
  return !!element(target)?.closest('[data-emoji-picker-container=true]');
};
